export const pageSizeOptions = ['5', '10', '25', '50', '100'];
export const PAGE_SIZE_STORAGE_KEY = 'pageSize';
export const DOCUMENT_PAGE_SIZE_STORAGE_KEY = 'documentPageSize';
export const DOCUMENT_CURRENT_PAGE_STORAGE_KEY = 'documentPageCurrent';
